import '~/pages/projects/show/index';
import initVueAlerts from '~/vue_alerts';
import initTierBadgeTrigger from 'ee/groups/init_tier_badge_trigger';

initVueAlerts();
initTierBadgeTrigger();
